<template>
  <select :value="busstopId" @change="setBusstop" class="w-full p-4 bg-gray-200 border-gray-200">
    <option disabled>地図またはリストから選択</option>
    <option v-for="busstop in busstops" :key="busstop.id" :value="busstop.id" :disabled="!busstop[isEnableAttribute]">{{ busstop.name }}</option>
  </select>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    isEnableAttribute: {
      type: String,
      required: true
    },
    setDefaultBusstop: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      busstops: 'busstops/getAll'
    }),
    busstopId: function () {
      const b = this.busstops[0]
      const id = this.value && this.value.id || b.id

      // この処理をしないと、storeにはないから、選択をそのままで仮予約をした際にエラーになってしまう
      if (!(this.value && this.value.id)) {
        this.setDefaultBusstop(b)
      }

      return id
    }
  },
  methods: {
    getBusstop: function (id) {
      return this.busstops.find((busstop) => busstop.id == id)
    },
    setBusstop: function (e) {
      const busstop = this.getBusstop(e.target.value)
      this.$emit('input', busstop)
    }
  }
}
</script>
